module.exports = __webpack_public_path__ + "static/img/logo_white.da43652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/logo_white.png
// module id = m3o3
// module chunks = 1